<app-title-pages-component
  [pageData]="pageData"
  [showClientName]="true">
</app-title-pages-component>

<app-table-component
  [columns]="columnDefinitions"
  [data]="campaigns"
  [onEdit]="editCampaing"
  [onAdd]="addCampaing"
  [onDelete]="showConfirmDeleteDialog"
  [editMode]="showBtn"
  [labelForSearch]="'Buscar campaña'"
  [nameButton]="'Crear campaña'"
  [actionsIcons]="actionsIcons"
></app-table-component>

@if(showModal){
  <app-confirm-delete-dialog
    [message]="message"
    (confirmar)="handleDelete()"
    (cancelar)="handleCancelDeleteDialog()"
  ></app-confirm-delete-dialog>
}

@if (showModalPasosCampaign) {
  <app-modal-pasos-campana (cerrar)="closeModalPasosCampaign()"></app-modal-pasos-campana>
}
